/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {Label as StyledLabel} from './style';

interface ILabel {
  text: string;
  htmlFor?: string;
  color?: string;
  icon?: JSX.Element;
  className?: string;
}

export const Label = ({text, htmlFor, color, icon, className}: ILabel): JSX.Element => (
  <StyledLabel
    className={className}
    htmlFor={htmlFor}
    color={color}
  >
    {text} {icon}
  </StyledLabel>
);